import React from 'react';
import { withRouter, RouteComponentProps } from 'react-router';
import { Stack } from '@servicetitan/design-system';
import { RouteParams } from '../../signature-routes';
import { observer } from 'mobx-react';
import { lazyInject } from 'src/signature/ioc';
import { SignatureStore } from 'src/signature/stores/signature.store';
import { signatureTypeEnumToString } from 'src/signature/util/signatureTypeEnumToString';
import { DocumentDownloadCard } from './document-download-card';
import { VisitAssistantHeader } from '../../visit-assistant-header/visit-assistant-header';
import { PageContainer } from '../../page-container/page-container';
import pageStyles from '../../signature-page/signature-page.less';

interface DocumentDocumentState {
    header?: string | null;
}

@observer
class DocumentDocumentUnwrapped extends React.Component<
    RouteComponentProps<RouteParams>,
    DocumentDocumentState
> {
    @lazyInject(SignatureStore) private signatureStore!: SignatureStore;

    documentPdfUrl?: string;

    constructor(props: RouteComponentProps<RouteParams>) {
        super(props);
        this.state = {
            header: null,
        };
        this.init();
    }

    componentDidMount() {
        const { history, match } = this.props;
        const { visitActionId } = match.params;
        const query = new URLSearchParams(this.props.location.search);
        const signatureType = query.get('signatureType');
        this.setDocumentUrl();

        if (signatureType) {
            this.setState({
                header: signatureTypeEnumToString(parseInt(signatureType, 10)),
            });
        }

        if (!this.documentPdfUrl) {
            history.push(`/signatures/${visitActionId}`);
        }
    }

    componentWillUnmount() {
        this.signatureStore.setCurrentFormName();
    }

    init = async () => {
        const { match } = this.props;
        const { visitActionId, submittingId } = match.params;
        await this.signatureStore.getVisitActionRequest(visitActionId);

        if (submittingId) {
            await this.signatureStore.fetchFormName(submittingId);
        }
    };

    setDocumentUrl() {
        const { invoiceSignatureId, projectSignatureId, submittingId } = this.props.match.params;
        const isInvoiceSignature = Boolean(invoiceSignatureId || projectSignatureId);

        let documentPdfUrl;
        if (isInvoiceSignature) {
            documentPdfUrl = this.getDocumentPdfUrl(
                `invoice-signature-request/${invoiceSignatureId}`
            );
        }

        if (projectSignatureId) {
            documentPdfUrl = this.getDocumentPdfUrl(
                `project-signature-request/${projectSignatureId}`
            );
        }

        if (submittingId) {
            documentPdfUrl = this.getDocumentPdfUrl(submittingId, 'form', 'download');
        }

        this.documentPdfUrl = documentPdfUrl;
    }

    getDocumentPdfUrl(subpath: string, entity: string = 'invoice', action: string = 'print') {
        const { visitActionId } = this.props.match.params;
        return `/api/${entity}s/${subpath}/${action}?visitActionRequestId=${visitActionId}`;
    }

    render() {
        const { header } = this.state;
        const { businessUnitOfficialName, currentCustomFormName } = this.signatureStore;
        const docHeader = header || currentCustomFormName;

        if (!this.documentPdfUrl || !docHeader) {
            return null;
        }

        return (
            <PageContainer>
                <VisitAssistantHeader showTenantName tenantName={businessUnitOfficialName} />
                {}
                <Stack direction="column" className={pageStyles.pageContent}>
                    <DocumentDownloadCard header={docHeader} documentPdfUrl={this.documentPdfUrl} />
                </Stack>
                {}

                {}
            </PageContainer>
        );
    }
}

export const DocumentDownload = withRouter(DocumentDocumentUnwrapped);
